import { app } from "@microsoft/teams-js";
import { SurveyDTO } from "@teams/types/api";
import { useCallback, useState } from "react";

import { isError } from "../../../../_shared/services/ChannelApi";
import { ChannelSurveysOptions, surveyApi } from "../../../../_shared/services/SurveyApi";

export function useMeetingSurveys(
  teamsContext: app.Context,
  sortCallback?: (a: SurveyDTO, b: SurveyDTO) => number
) {
  const [surveys, setSurveys] = useState<SurveyDTO[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>();
  const [error, setError] = useState<Error>();

  const loadSurveys = useCallback(
    async (options: ChannelSurveysOptions, suppressError?: boolean) => {
      setError(undefined);
      setIsLoading(true);

      const surveysResponse = await surveyApi.audienceSurveys(teamsContext, options);
      setIsLoading(false);

      if (isError(surveysResponse)) {
        if (!suppressError) {
          setError(surveysResponse);
        }
      } else {
        if (sortCallback) {
          setSurveys(surveysResponse.sort(sortCallback));
        } else {
          setSurveys(surveysResponse);
        }
      }
    },
    [teamsContext, sortCallback]
  );

  return { surveys, setSurveys, loadSurveys, isLoading, error };
}
